module.exports = __webpack_public_path__ + "static/img/v78.369da28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v78.png
// module id = LH6h
// module chunks = 1